<div class="slide-zoom"><ng-content></ng-content></div>